import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_17_4631)" }, /* @__PURE__ */ React.createElement("path", { d: "M9.00016 16.17L4.83016 12L3.41016 13.41L9.00016 19L21.0002 6.99997L19.5902 5.58997L9.00016 16.17Z" })));
export default SvgCheck;
